module.exports = __webpack_public_path__ + "static/hero-org-charting-a0863cea530eab90a89e2ddd6d145cfa.svg";